// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/BiouvFluidspf50.jpg";
import thumb1 from "../assets/images/All-Products/Product-Photo_Fluid-1.png";
import thumb2 from "../assets/images/New-Products/BiouvFluidspf50.jpg";
import thumb3 from "../assets/images/New-Products/extra/Biouvfluid2.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2> BioUV Fluid SPF 50</h2>
              <p className="sub-heading text-muted">Invisible Shield for your skin </p>
              <h5>Product Overview</h5>
              <p>
                Cutting-edge range of BioUV which is Broad Spectrum Fluid Sunscreen with multitasking
                SPF 50 that provides pollution defence and exposome protection.
                This sunscreen is ultra-light anhydrous gel, offering a thin texture that feels almost invisible on the skin,
                and it is absorbed quickly and leaves no white cast.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight"> BioUV Fluid SPF 50 ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients", "precautions"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : tab === "precautions"
                          ? "PRECAUTIONS"
                          : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li><strong>SPF 50, PA++++:</strong> UV A/B broad spectrum protection.</li>
                    <li><strong>Ultra-light anhydrous gel:</strong> Provides an invisible finish.</li>
                    <li><strong>Protection:</strong> UV + Blue light + Pollution control.</li>
                    <li><strong>Heat Shield:</strong> Shields skin from 2 degrees of heat.</li>
                    <li><strong>Free From:</strong> Paraben and Silicone. Non-comedogenic.</li>
                    <li><strong>No White Cast:</strong> Leaves no white cast.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Take 2 finger-tip units.</li>
                      <li>Apply liberally and evenly to the exposed areas of the skin.</li>
                      <li>Wait for 20 minutes before going out in the sun.</li>
                      <li>Reapply every 2 hours for continuous protection</li>
                      <li>Ensure thorough rubbing as the product contains 20% zinc</li>
                    </ol>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li><strong>Gen Z UV filters:</strong> Photostable to highly photostable. These filters do not change under the influence of sunlight, and their effectiveness remains consistent even after prolonged sun exposure. These filters provide protection from UV A/B and HEVL.</li>
                      <li><strong>De-stress technology:</strong> It quenches free radicals and effectively inhibits oxidative stress. Protects from Blue light + heat + pollution.</li>
                      <li><strong>Niacinamide:</strong> Vitamin B3 derivative that reduces the appearance of pores, fine lines, blemish marks, and uneven texture. Strengthens the skin barrier and retains moisture.</li>
                      <li><strong>Ceramide Complex:</strong> Ceramide creates a water-impermeable, protective layer to prevent excessive water loss due to evaporation and acts as a barrier against the entry of microorganisms. It helps repair the skin barrier function, improve skin hydration, and reduce TEWL.</li>
                      <li><strong>Hyaluronic Acid:</strong> Reduces Trans Epidermal Water Loss and promotes hydration in the skin.</li>
                    </ol>

                  </p>
                </div>
              )}
              {activeTab === "precautions" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Avoid contact with eyes.</li>
                      <li>If the sunscreen gets into the eyes, rinse thoroughly using cold water.</li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
